var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconfeatherHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 9.00636C3.33301 8.10119 3.33301 7.64861 3.51598 7.25078C3.69896 6.85296 4.04258 6.55842 4.72984 5.96934L5.39651 5.39791C6.63872 4.33316 7.25983 3.80078 7.99967 3.80078C8.73952 3.80078 9.36063 4.33316 10.6028 5.39791L11.2695 5.96934C11.9568 6.55842 12.3004 6.85296 12.4834 7.25078C12.6663 7.64861 12.6663 8.10119 12.6663 9.00637V11.8333C12.6663 13.0904 12.6663 13.7189 12.2758 14.1094C11.8853 14.5 11.2568 14.5 9.99967 14.5H5.99967C4.7426 14.5 4.11406 14.5 3.72353 14.1094C3.33301 13.7189 3.33301 13.0904 3.33301 11.8333V9.00636Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66634 14.5V11.5C9.66634 10.9477 9.21863 10.5 8.66634 10.5H7.33301C6.78072 10.5 6.33301 10.9477 6.33301 11.5V14.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherHome);
export default __webpack_public_path__ + "static/media/Icon feather-home.61502453.svg";
export { ForwardRef as ReactComponent };